/** Словарь интерфейса (интерфейс только на английском, ADR-0021); `MessageKey` — набор ключей. */
export const en = {
  'app.name': 'Acuta',
  'notFound.title': 'Page not found',
  'notFound.back': 'Back to home',
  'nav.login': 'Sign in',
  'nav.logout': 'Sign out',
  'menu.open': 'Account menu',
  'menu.workspaces': 'Workspaces',
  'menu.allWorkspaces': 'All workspaces',
  'menu.invitations': 'Invitations',
  'menu.workspaceSettings': 'Workspace settings',
  'menu.profile': 'Profile and security',
  'settings.back': 'Back to diagrams',
  'settings.account': 'Account',
  'settings.workspace': 'Workspace',
  'landing.tagline': 'Audit programs as diagrams — built with an AI assistant.',
  'landing.openApp': 'Open the app',
  'landing.signUp': 'Create an account',
  'common.loading': 'Loading…',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.confirm': 'Confirm',
  'common.delete': 'Delete',
  'common.more': 'More actions',
  'canvas.hypothesis': 'Hypothesis',
  'canvas.loadFailed': 'Could not load the diagram.',
  'canvas.deleted': 'This diagram was deleted or you no longer have access to it.',
  'canvas.backToList': 'Back to diagrams',
  'canvas.assistant.show': 'Show assistant',
  'canvas.assistant.hide': 'Hide assistant',
  'canvas.warning.LINK_NOT_DOWNWARD': 'The link does not go down a level.',
  'canvas.warning.LINK_SKIPS_LEVEL': 'The link skips a level.',
  'canvas.tool.drag': 'Drag along the level',
  'canvas.tool.chat': 'Ask the assistant about the card',
  'canvas.add.top': 'Add a card a level above',
  'canvas.add.bottom': 'Add a card a level below',
  'canvas.add.left': 'Add a card to the left',
  'canvas.add.right': 'Add a card to the right',
  'canvas.rollUp': 'Collapse',
  'canvas.rollOut': 'Expand',
  'link.deleteTitle': 'Delete the link?',
  'link.deleteDescription': 'The cards stay. You can undo this.',
  'canvas.warning.REVERT_SKIPPED':
    'Part of the change was not reverted: someone else changed it after you.',
  'card.label': 'Title',
  'card.description': 'Description',
  'card.namePlaceholder': 'Enter the card name',
  'card.descriptionPlaceholder': 'Enter text...',
  'card.descriptionHint': 'Use no more than {n} characters',
  'card.parents': 'Parent cards',
  'card.children': 'Child cards',
  'card.selectCards': 'Select cards',
  'card.addMore': 'Add…',
  'card.unlink': 'Remove',
  'card.changedAt': 'Modified: {date}',
  'card.deleteTitle': 'Confirm deletion',
  'card.deleteDescription': 'Do you really want to delete this card?',
  'commands.label': 'Diagram commands',
  'commands.add': 'Add a card',
  'commands.order': 'Arrange cards',
  'commands.orderNoRights': 'Arrange cards — no edit permission',
  'commands.import': 'Import (JSON)',
  'commands.export': 'Export the diagram: an image, JSON or CSV',
  'commands.undo': 'Undo (Ctrl/⌘ + Z)',
  'commands.redo': 'Redo (Ctrl/⌘ + Shift + Z)',
  'commands.nothingToUndo': 'Nothing to undo',
  'commands.nothingToRedo': 'Nothing to redo',
  'commands.versions': 'Versions',
  'commands.markSeen': 'Mark changes as seen',
  'commands.markSeenCount': 'Changes: {n} — mark as viewed',
  'commands.noChanges': 'No changes',
  'addCard.title': 'New card',
  'addCard.type': 'Type',
  'addCard.submit': 'Create',
  'export.title': 'Export',
  'export.format': 'File format',
  'export.scope': 'Mode',
  'export.scope.cards': 'Cards only',
  'export.scope.full': 'Full',
  'export.pngHint':
    'A picture of the whole diagram as drawn — the current zoom on the canvas does not affect it.',
  'export.csvNote': 'CSV exports cards only, without nested fields.',
  'export.download': 'Download',
  'export.preparing': 'Preparing…',
  'export.failed': 'Could not prepare the file.',
  'import.done': 'Imported',
  'import.title': 'Import',
  'import.file': 'File (JSON)',
  'import.mode': 'Mode',
  'import.cardsOnly': 'Cards only',
  'import.full': 'Full',
  'import.submit': 'Import',
  'import.submitting': 'Importing…',
  'import.cards': 'cards',
  'import.links': 'links',
  'import.badFile': 'This is not a diagram file exported from Acuta.',
  'versions.title': 'Versions',
  'versions.description':
    'Automatic every 100 changes, and named ones you save. Restoring can be undone.',
  'versions.name': 'Version name',
  'versions.save': 'Save version',
  'versions.empty': 'No versions yet.',
  'versions.auto': 'Automatic version',
  'versions.revision': 'revision',
  'versions.restore': 'Restore',
  'versions.restoreTitle': 'Restore this version?',
  'versions.restoreDescription': 'The diagram will return to this state. You can undo it.',
  'diagram.rename': 'Rename',
  'diagram.name': 'Name',
  'diagram.deleteTitle': 'Delete flowchart',
  'diagram.deleteDescription': 'The diagram will be deleted together with its chats.',
  'tool.arguments': 'Arguments',
  'tool.result': 'Result',
  'prompt.title': 'Ask the assistant',
  'prompt.toggle': 'Prompt on the canvas',
  'prompt.toggleHint': 'Prompt on canvas: click a card or a spot to ask the assistant',
  'prompt.toggleOff': 'Leave prompt mode (Esc)',
  'prompt.placeholder': 'What should happen here?',
  'prompt.send': 'Send to chat',
  'prompt.cardLine': 'Card {code} «{label}»',
  'agent.banner.changed': 'The assistant changed {count} card(s) — they are outlined.',
  'agent.banner.skips':
    'The assistant linked cards across a level: {count}. Check whether a step is missing.',
  'agent.banner.show': 'Show',
  'agent.banner.hide': 'Hide',
  'agent.banner.dismiss': 'Got it',
  'home.title': "Let's create or update program",
  'home.diagramSelect': 'Which diagram the message is for',
  'home.quickAria': 'Quick suggestions',
  'home.brandTitle': 'Home',
  'home.deleteMessage': '“{name}” will be deleted together with its chats. This cannot be undone.',
  'home.actionsFor': 'Actions for “{name}”',
  'home.chatLabel': 'Message to the assistant',
  'home.placeholder': 'What shall we do?',
  'home.newDiagram': 'New diagram',
  'home.untitled': 'New diagram',
  'home.cannotCreate': 'You cannot create diagrams in this workspace.',
  'home.suggest.check': 'Check my diagram',
  'home.suggest.checkText': 'Check my diagram',
  'home.suggest.scratch': 'Create an audit program from scratch',
  'home.suggest.scratchText': 'Create an audit program from scratch',
  'home.suggest.files': 'Build a program from ready files',
  'home.suggest.filesText': 'Build an audit program from the attached files',
  'home.diagrams': 'Diagrams',
  'home.empty': 'No diagrams yet — start with a message above or press «+».',
  'home.emptyDiagram': 'Empty diagram',
  'home.view.label': 'List view',
  'home.view.table': 'Table',
  'home.view.tiles': 'Tiles',
  'home.column.name': 'Name',
  'home.column.changed': 'Changed',
  'home.create': 'Create',
  'home.duplicate': 'Duplicate',
  'home.copyOf': '{name} (copy)',
  'security.title': 'Security',
  'nodeType.HLRSC': 'High-level risk',
  'nodeType.RSC': 'Risk',
  'nodeType.RSCF': 'Risk factor',
  'nodeType.CTRL': 'Control',
  'nodeType.ACR': 'Assessment criterion',
  'nodeType.WP': 'Audit procedure',
  'nodeType.D': 'Observation',
  'nodeType.C': 'Conclusion',
  'nodeType.R': 'Recommendation',
  'nodeType.M': 'Action',
  'validation.required': 'Required.',
  'validation.email': 'Enter a valid email.',
  'validation.invalid': 'Invalid value.',
  'validation.passwordTooShort': 'At least 10 characters.',
  'validation.tooLong': 'Too long.',
  'validation.passwordsDiffer': 'Passwords do not match.',
  'validation.code': 'Enter the code.',
  'auth.field.email': 'Email',
  'auth.field.password': 'Password',
  'auth.field.name': 'Name',
  'auth.field.newPassword': 'New password',
  'auth.field.confirmPassword': 'Repeat new password',
  'auth.field.currentPassword': 'Current password',
  'auth.field.code': 'Code',
  'auth.field.passwordHint': 'At least 10 characters. A phrase of several words works well.',
  'auth.toLogin': 'Back to sign in',
  'auth.login.title': 'Sign in',
  'auth.login.submit': 'Sign in',
  'auth.login.toRegister': 'Create an account',
  'auth.login.forgot': 'Forgot password?',
  'auth.google.signIn': 'Continue with Google',
  'auth.secondFactor.title': 'Two-factor authentication',
  'auth.secondFactor.hint':
    'Enter the 6-digit code from your authenticator app or one of your recovery codes.',
  'auth.secondFactor.submit': 'Verify',
  'auth.secondFactor.restart': 'Sign in again',
  'auth.register.title': 'Create an account',
  'auth.register.submit': 'Create account',
  'auth.register.toLogin': 'Already have an account? Sign in',
  'auth.register.checkMailTitle': 'Check your email',
  'auth.register.checkMail':
    'We sent a confirmation link to your email. Open it to finish creating your account.',
  'auth.verify.title': 'Email confirmation',
  'auth.verify.hint': 'Enter the password you chose at sign-up to confirm your email and sign in.',
  'auth.verify.submit': 'Confirm and sign in',
  'auth.verify.resend': 'Send the confirmation email again',
  'auth.verify.resent': 'If the email is registered and not confirmed yet, we sent a new link.',
  'auth.forgot.title': 'Reset password',
  'auth.forgot.hint': 'Enter your email and we will send a link to set a new password.',
  'auth.forgot.submit': 'Send link',
  'auth.forgot.sent': 'If an account exists for this email, we sent a link to reset the password.',
  'auth.reset.title': 'New password',
  'auth.reset.submit': 'Set password',
  'auth.reset.done':
    'Password updated. All sessions were signed out — sign in with the new password.',
  'auth.confirmEmail.title': 'New email confirmation',
  'auth.confirmEmail.done': 'Your new email is confirmed.',
  'profile.title': 'Profile',
  'profile.general.title': 'General',
  'profile.avatar.title': 'Avatar',
  'profile.avatar.upload': 'Upload image',
  'profile.avatar.remove': 'Remove',
  'profile.avatar.hint': 'JPEG, PNG, WebP, GIF or AVIF up to 5 MB. It will be cropped to a square.',
  'profile.email.title': 'Email',
  'profile.email.verified': 'confirmed',
  'profile.email.unverified': 'not confirmed',
  'profile.email.new': 'New email',
  'profile.email.submit': 'Change email',
  'profile.email.sent': 'Check the new address: we sent a confirmation link there.',
  'profile.passwordRequired': 'Set a password first: use “Forgot password?” on the sign-in page.',
  'profile.password.title': 'Password',
  'profile.password.submit': 'Change password',
  'profile.password.changed': 'Password changed. Other sessions were signed out.',
  'profile.password.notSet': 'You sign in with Google and have no password yet. To set one, use',
  'profile.2fa.title': 'Two-factor authentication',
  'profile.2fa.off': 'Protect your account with a code from an authenticator app.',
  'profile.2fa.enable': 'Set up',
  'profile.2fa.scan':
    'Scan the QR code with an authenticator app (Google Authenticator, 1Password, Authy…) and enter the code it shows.',
  'profile.2fa.qrAlt': 'QR code for the authenticator app',
  'profile.2fa.manual': 'Or enter the key manually:',
  'profile.2fa.confirm': 'Turn on',
  'profile.2fa.on': 'Two-factor authentication is on.',
  'profile.2fa.remaining': 'Recovery codes left:',
  'profile.2fa.regenerate': 'New recovery codes',
  'profile.2fa.appCode': 'Code from the app',
  'profile.2fa.regenerateSubmit': 'Generate new codes',
  'profile.2fa.disable': 'Turn off',
  'profile.2fa.disableSubmit': 'Turn off two-factor authentication',
  'profile.2fa.codesTitle': 'Recovery codes',
  'profile.2fa.codesHint':
    'Save them somewhere safe. Each code works once; they will not be shown again.',
  'profile.2fa.codesSaved': 'I saved the codes',
  'profile.google.title': 'Google',
  'profile.google.isLinked': 'A Google account is linked.',
  'profile.google.notLinked': 'No Google account is linked.',
  'profile.google.link': 'Link a Google account',
  'profile.google.unlink': 'Unlink',
  'profile.google.linked': 'Google account linked.',
  'profile.sessions.title': 'Active sessions',
  'profile.sessions.current': 'this device',
  'profile.sessions.revoke': 'Sign out',
  'profile.sessions.revokeOthers': 'Sign out all other sessions',
  'profile.sessions.lastSeen': 'last active',
  'profile.sessions.unknownDevice': 'Unknown device',
  'common.showMore': 'Show more',
  'common.formerUser': 'Former user',
  'workspaces.title': 'Workspaces',
  'workspaces.mine': 'My workspaces',
  'workspaces.preparing': 'Preparing your workspace…',
  'workspaces.notReady': 'Your workspace is not ready yet. Reload the page in a minute or open',
  'workspaces.personal': 'personal',
  'workspaces.archived': 'archived',
  'workspaces.toList': 'All workspaces',
  'workspaces.field.name': 'Name',
  'workspaces.create.title': 'New workspace',
  'workspaces.create.submit': 'Create',
  'workspaces.role.owner': 'owner',
  'workspaces.role.member': 'member',
  'workspace.tab.overview': 'Settings',
  'workspace.tab.members': 'Members',
  'workspace.tab.invitations': 'Invitations',
  'workspace.tab.audit': 'Activity log',
  'workspace.archivedNotice':
    'This workspace is archived: it is read-only and visible to owners only.',
  'workspace.rename.title': 'Name',
  'workspace.archive.title': 'Archive',
  'workspace.archive.hint':
    'Archived workspace becomes read-only and hidden from members. Pending invitations are revoked.',
  'workspace.archive.restoreHint':
    'Restore the workspace to make it editable and visible to members again.',
  'workspace.archive.submit': 'Archive workspace',
  'workspace.archive.restore': 'Restore from archive',
  'workspace.leave.title': 'Leave workspace',
  'workspace.leave.submit': 'Leave',
  'members.you': 'you',
  'members.role': 'Role',
  'members.remove': 'Remove',
  'invitations.inbox.title': 'Invitations for you',
  'invitations.expires': 'valid until',
  'invitations.expired': 'expired on',
  'invitations.accept': 'Accept',
  'invitations.decline': 'Decline',
  'invitations.new.title': 'Invite by email',
  'invitations.new.submit': 'Invite',
  'invitations.sent': 'Invitation sent to',
  'invitations.pending.title': 'Pending invitations',
  'invitations.pending.empty': 'No pending invitations.',
  'invitations.resend': 'Send again',
  'invitations.revoke': 'Revoke',
  'invitations.accept.title': 'Invitation',
  'invitations.accept.invites': 'invites you to the workspace',
  'invitations.accept.address': 'The invitation is for',
  'invitations.accept.otherAccount':
    'You are signed in with another email. Only the account with the invited address can accept.',
  'invitations.accept.signInFirst': 'Sign in or create an account with this email to accept.',
  'audit.filter.actor': 'Who',
  'audit.filter.action': 'Action',
  'audit.filter.from': 'From',
  'audit.filter.to': 'To',
  'audit.filter.any': 'Any',
  'audit.empty': 'No actions yet.',
  'audit.action.workspace.created': 'created the workspace',
  'audit.action.workspace.renamed': 'renamed the workspace',
  'audit.action.workspace.archived': 'archived the workspace',
  'audit.action.workspace.restored': 'restored the workspace',
  'audit.action.member.role-changed': 'changed a member role',
  'audit.action.member.removed': 'removed a member',
  'audit.action.member.left': 'left the workspace',
  'audit.action.invitation.created': 'invited a person',
  'audit.action.invitation.resent': 'sent an invitation again',
  'audit.action.invitation.revoked': 'revoked an invitation',
  'audit.action.invitation.accepted': 'accepted an invitation',
  'audit.action.invitation.declined': 'declined an invitation',
  'audit.action.diagram.created': 'created a diagram',
  'audit.action.diagram.updated': 'renamed or described a diagram',
  'audit.action.diagram.deleted': 'deleted a diagram',
  'audit.action.diagram.edited': 'edited a diagram',
  'audit.action.diagram.undone': 'undid a diagram change',
  'audit.action.diagram.redone': 'redid a diagram change',
  'audit.action.diagram.restored': 'restored a diagram version',
  'audit.action.diagram.version-created': 'saved a diagram version',
  'audit.action.diagram.comment-deleted': 'deleted a comment',
  'assistant.renameTitle': 'Rename the chat',
  'assistant.chatTitle': 'Chat name',
  'assistant.deleteTitle': 'Delete the chat?',
  'assistant.deleteDescription':
    'Its messages will be deleted for everyone. Changes to the diagram stay.',
  'assistant.answeredInChat': 'Will answer in the chat',
  'assistant.ask.decided': 'the assistant decides',
  'assistant.newChat': 'New chat',
  'assistant.rename': 'Rename',
  'assistant.deleteChat': 'Delete chat',
  'assistant.offline': 'connecting…',
  'assistant.empty': 'How can I help with the diagram?',
  'assistant.earlier': 'Earlier messages',
  'assistant.queued': 'In the queue — goes after the assistant finishes',
  'assistant.cancelled': 'Cancelled',
  'assistant.answers': 'Your answers',
  'assistant.reasoning': 'Reasoning',
  'assistant.interrupted': 'The answer was interrupted.',
  'assistant.changes': 'The assistant changed the diagram {count} time(s).',
  'assistant.undoRun': 'Undo these changes',
  'assistant.undone': 'Undone',
  'assistant.ask.title': 'Clarifications',
  'assistant.ask.own': 'Your own answer…',
  'assistant.ask.continue': 'Continue',
  'assistant.ask.decideAll': 'Decide everything for me',
  'assistant.placeholder': 'Ask about the diagram…',
  'assistant.message': 'Message',
  'assistant.send': 'Send',
  'assistant.queue': 'Add to queue',
  'assistant.stop': 'Stop',
  'assistant.usage': 'Runs today: {runs} · tokens this month (workspace): {tokens}',
  'assistant.comments': 'Comments',
  'canvasPrompt.comment': 'Add a comment on the card',
  'comments.empty':
    'No comments yet. Write one below or ask the assistant to review the flowchart.',
  'comments.placeholderCard': 'Comment on card {code}…',
  'comments.whole': 'Whole flowchart',
  'comments.assistant': 'Assistant',
  'comments.add': 'Add comment',
  'comments.addHint': 'Enter to add, Shift+Enter for a new line',
  'comments.reply': 'Reply',
  'comments.replyPlaceholder': 'Reply…',
  'comments.deleteFor': 'Delete comment',
  'comments.deleteTitle': 'Delete comment',
  'comments.deleteMessage': 'The comment is deleted together with its replies.',
  'comments.select': 'Select to send to the chat',
  'comments.highlight': 'Highlight the cards on the canvas',
  'comments.dismiss': 'Dismiss',
  'comments.sendToAgent': 'Send to agent',
  'comments.selectCard': 'Select a card on the canvas to add a comment.',
  'comments.chatIntro': 'Work through these comments:',
  'comments.chatWhole': 'whole flowchart',
  'comments.chatReply': 'reply',
  'comments.noRights': 'You have no permission to comment on this flowchart.',
  'assistant.chats': 'Chats',
  'assistant.chatsOfDiagram': 'Diagram chats',
  'assistant.actions': 'Chat actions',
  'assistant.actionsPending': 'The chat appears after the first message',
  'assistant.noChats': 'No chats for this diagram yet',
  'assistant.copy': 'Copy',
  'assistant.copied': 'Copied',
  'assistant.reasoningNow': 'Thinking…',
  'assistant.ask.preparing': 'The assistant is preparing questions…',
  'assistant.ask.pending':
    'The assistant asked questions ({count}) — answer in the window above the canvas',
  'assistant.ask.summaryChat': 'Answered in the chat',
  'assistant.ask.optional': 'All questions are optional: what you skip, the assistant decides.',
  'assistant.ask.close': 'Close — I will answer in the chat',
  'tool.status.running': 'Running',
  'tool.status.done': 'Done',
  // Коды ошибок API (AGENTS.md §10): сервер присылает код, текст — здесь.
  'error.INTERNAL': 'Something went wrong. Please try again later.',
  'error.AUTH_REQUIRED': 'Please sign in to continue.',
  'error.CSRF_HEADER_MISSING': 'The request was rejected by the security check.',
  'error.VALIDATION_FAILED': 'Please check the highlighted fields.',
  'error.RATE_LIMITED': 'Too many attempts. Please wait a moment.',
  'error.FORBIDDEN': 'You do not have access to this.',
  'error.ROUTE_NOT_FOUND': 'Not found.',
  'error.BAD_REQUEST': 'The request could not be processed.',
  'error.METHOD_NOT_ALLOWED': 'This action is not available.',
  'error.PAYLOAD_TOO_LARGE': 'The data is too large.',
  'error.UNSUPPORTED_MEDIA_TYPE': 'This format is not supported.',
  'error.HTTP_ERROR': 'The request failed.',
  'error.NETWORK': 'No connection to the server.',
  'error.UNKNOWN': 'Unexpected error.',
  'error.AUTH_INVALID_CREDENTIALS': 'Wrong email or password.',
  'error.AUTH_EMAIL_NOT_VERIFIED': 'Confirm your email first: open the link we sent you.',
  'error.AUTH_VERIFY_PASSWORD_MISMATCH':
    'This password does not match the sign-up. If you do not remember it, reset the password.',
  'error.AUTH_TOKEN_INVALID': 'The link is invalid or expired. Request a new one.',
  'error.AUTH_PASSWORD_TOO_WEAK': 'The password is too short.',
  'error.AUTH_WRONG_PASSWORD': 'The current password is wrong.',
  'error.AUTH_PASSWORD_NOT_SET': 'Set a password first using password reset.',
  'error.AUTH_EMAIL_TAKEN': 'This email is already in use.',
  'error.AUTH_SECOND_FACTOR_EXPIRED': 'The sign-in attempt expired. Sign in again.',
  'error.AUTH_SECOND_FACTOR_INVALID': 'The code is wrong or already used.',
  'error.AUTH_2FA_ALREADY_ENABLED': 'Two-factor authentication is already on.',
  'error.AUTH_2FA_NOT_ENABLED': 'Two-factor authentication is off.',
  'error.AUTH_2FA_SETUP_NOT_STARTED': 'Start the setup again.',
  'error.SESSION_NOT_FOUND': 'The session is already closed.',
  'error.AVATAR_INVALID': 'This file is not a supported image.',
  'error.AUTH_GOOGLE_DISABLED': 'Sign-in with Google is not available.',
  'error.AUTH_OAUTH_STATE_INVALID': 'The Google sign-in expired or was interrupted. Try again.',
  'error.AUTH_OAUTH_FAILED': 'Google did not confirm the sign-in. Try again.',
  'error.AUTH_GOOGLE_ACCOUNT_EXISTS':
    'An account with this email already exists. Sign in with your password and link Google in your profile.',
  'error.AUTH_GOOGLE_EMAIL_NOT_VERIFIED': 'Your Google account email is not verified.',
  'error.AUTH_GOOGLE_IDENTITY_IN_USE': 'This Google account is linked to another user.',
  'error.AUTH_GOOGLE_ALREADY_LINKED': 'A Google account is already linked.',
  'error.AUTH_GOOGLE_NOT_LINKED': 'No Google account is linked.',
  'error.AUTH_LAST_SIGN_IN_METHOD': 'This is your only way to sign in. Set a password first.',
  'error.CURSOR_INVALID': 'The list position is outdated. Reload the page.',
  'error.WORKSPACE_NOT_FOUND': 'Workspace not found or you have no access to it.',
  'error.WORKSPACE_PERMISSION_DENIED': 'Your role does not allow this.',
  'error.WORKSPACE_ARCHIVED': 'The workspace is archived and read-only.',
  'error.WORKSPACE_PERSONAL_PROTECTED':
    'A personal workspace cannot be archived, and its creator always stays its owner.',
  'error.WORKSPACE_LAST_OWNER': 'The workspace must keep at least one owner.',
  'error.WORKSPACE_MEMBER_NOT_FOUND': 'This person is no longer a member.',
  'error.WORKSPACE_ALREADY_MEMBER': 'This person is already a member.',
  'error.INVITATION_NOT_FOUND': 'The invitation is no longer available.',
  'error.INVITATION_INVALID': 'The invitation link is invalid or expired.',
  'error.INVITATION_EMAIL_MISMATCH': 'The invitation is for another email address.',
  'error.INVITATION_ALREADY_PENDING':
    'This email is already invited. Send the invitation again instead.',
  'error.INVITATION_LIMIT_REACHED':
    'Too many pending invitations. Revoke the ones you do not need.',
  'error.DIAGRAM_INVALID': 'Diagram name or description is invalid.',
  'error.DIAGRAM_NOT_FOUND': 'Diagram not found: it was deleted or belongs to another workspace.',
  'error.DIAGRAM_NODE_NOT_FOUND': 'The card no longer exists: someone has deleted it.',
  'error.DIAGRAM_LINK_NOT_FOUND': 'The link no longer exists.',
  'error.DIAGRAM_VERSION_NOT_FOUND': 'The version no longer exists.',
  'error.DIAGRAM_REF_INVALID': 'The change refers to a card that is not in it.',
  'error.DIAGRAM_NODE_INVALID': 'Card fields are invalid.',
  'error.DIAGRAM_LINK_SELF': 'A card cannot be linked to itself.',
  'error.DIAGRAM_LINK_EXISTS': 'These cards are already linked.',
  'error.DIAGRAM_CYCLE': 'This link would create a cycle.',
  'error.DIAGRAM_TOO_LARGE': 'The diagram has reached the card limit.',
  'error.DIAGRAM_CHANGE_TOO_LARGE': 'The change is too large. Split it into smaller ones.',
  'error.DIAGRAM_NOTHING_TO_UNDO': 'Nothing to undo.',
  'error.DIAGRAM_NOTHING_TO_REDO': 'Nothing to redo.',
  'error.DIAGRAM_REVISION_AHEAD': 'The diagram is out of sync. Reload it.',
  'error.DIAGRAM_COMMENT_NOT_FOUND': 'The comment has already been deleted.',
  'error.DIAGRAM_COMMENT_INVALID': 'The comment could not be saved: check its text and cards.',
  'error.DIAGRAM_COMMENTS_LIMIT': 'The diagram has too many comments. Delete some of them.',
  'error.REALTIME_TOPIC_UNKNOWN': 'Live updates are not available for this.',
  'error.REALTIME_SUBSCRIPTION_LIMIT': 'Too many open diagrams. Close some tabs.',
  'error.REALTIME_SUBSCRIPTION_CONFLICT': 'Live updates were reset. Reopen the diagram.',
  'error.REALTIME_MESSAGE_INVALID': 'Live updates request was rejected.',
  'error.ASSISTANT_DISABLED': 'The assistant is not configured on this server.',
  'error.CHAT_THREAD_NOT_FOUND': 'The chat no longer exists.',
  'error.AGENT_RUN_NOT_FOUND': 'The assistant run no longer exists.',
  'error.ASSISTANT_INPUT_INVALID': 'The message is empty or too long.',
  'error.ASSISTANT_QUOTA_EXCEEDED': 'The assistant limit is used up. Try again after it resets.',
  'error.ASSISTANT_QUESTION_NOT_PENDING': 'This question has already been answered.',
  'error.AGENT_RUN_ACTIVE': 'Wait until the assistant finishes.',
  'error.ASSISTANT_STEP_LIMIT':
    'The assistant stopped: too many steps in one turn. Ask it to continue.',
  'error.ASSISTANT_TIME_LIMIT':
    'The assistant stopped: the turn took too long. Ask it to continue.',
  'error.ACCESS_REVOKED': 'The assistant stopped: the author no longer has access.',
  'error.RUN_INTERRUPTED':
    'The assistant was interrupted by a server restart. Send the message again.',
  'error.LLM_TIMEOUT': 'The model did not respond in time. Try again.',
  'error.LLM_UNAVAILABLE': 'The model is unavailable. Try again later.',
  'error.LLM_RATE_LIMITED': 'The model is overloaded. Try again in a minute.',
  'error.LLM_AUTH_FAILED': 'The model rejected the server key. Tell the administrator.',
  'error.LLM_CONTEXT_TOO_LONG': 'The conversation is too long for the model. Start a new chat.',
  'error.LLM_REJECTED': 'The model rejected the request.',
  'error.RUN_CANCELLED': 'The assistant was stopped.',
} as const;

export type MessageKey = keyof typeof en;
